export default __webpack_public_path__ + "static/ipoh_retreat-242e5d5f6499f45344519d39179b3665.jpg";